import React from "react";
import { Form, Input, Button, Spin, Select } from "antd";
import { ReactSVG } from "react-svg";

const CompanyAdminForm = ({ form, isFetching, companyAdmin, companies, handleSubmit, handleCancel }) => {
  return (
    <Spin spinning={isFetching}>
      <div className="CompanyAdminForm">
        <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleSubmit}>
          <div className="FormHeader">
            <div className="left">{companyAdmin ? "Edit Company Admin" : "Add New Company Admin"}</div>
          </div>
          <div className="FormContent">
            {!companyAdmin && (
              <Form.Item label="Company" name="company" rules={[{ required: true, message: "Required" }]}>
                <Select size="large" placeholder="Companies" showSearch optionFilterProp="children">
                  {companies.map(c => (
                    <Select.Option key={c._id} value={c._id}>
                      {c.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}
            <Form.Item label="Name" name="name" rules={[{ required: true, message: "Required" }]}>
              <Input size="large" placeholder="Name" />
            </Form.Item>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { type: "email", message: "Invalid Email" },
                { required: true, message: "Required" },
              ]}>
              <Input size="large" placeholder="Email" />
            </Form.Item>
            <Form.Item label="Password" name="password" rules={[{ required: !companyAdmin, message: "Required" }]}>
              <Input.Password size="large" placeholder="Password" />
            </Form.Item>
          </div>
          <div className="FormFooter">
            <div className="Left"></div>
            <div className="Right">
              <Button key="cancel" onClick={handleCancel}>
                Cancel
              </Button>
              <Button htmlType="submit" type="primary">
                {companyAdmin ? "Update" : "Create"}
                <ReactSVG className="icon" src="/icons/submit.svg" />
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default CompanyAdminForm;
